var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ascentInLogBook || _vm.inMyTickList)?_c('v-icon',{attrs:{"small":"","title":_vm.title(),"color":_vm.color()}},[_vm._v("\n  "+_vm._s(_vm.icon())+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }